import axios from 'axios';
import {
  addressUrl,
  reverseGeocodeUrl,
  convertAddressToCoordinatesUrl,
  adressTagUrl,
} from '../url';
import { getTokenHeader, getToken } from '../../../../../screen/auth/action';

export const reverseGeocodeAction = async (lat, lng) => {
  return new Promise(async (next) => {
    const token = await getToken();

    await axios
      .get(
        `${reverseGeocodeUrl()}?latitude=${lat}&longitude=${lng}`,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const convertAddressToCoordinates = async (address) => {
  return new Promise(async (next) => {
    const token = await getToken();

    await axios
      .post(
        convertAddressToCoordinatesUrl(),
        { address },
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};


export const addressDetailAction = async () => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${addressUrl()}`, { ...getTokenHeader(token) })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const saveAddressAction = async (payload) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .post(addressUrl(), payload, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const deleteAddressAction = async (payload) => {
  return new Promise(async (next) => {
    const params = new URLSearchParams(payload);
    let token = await getToken();
    await axios
      .delete(addressUrl(), {
        params: params,
        ...getTokenHeader(token),
      })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const editAddressAction = async (payload) => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .patch(addressUrl(), payload, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return err;
      });
  });
};

export const getAddressTagsAction = async () => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${adressTagUrl()}`, { ...getTokenHeader(token) })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};